import { render, staticRenderFns } from "./asynclive.vue?vue&type=template&id=ac9d2876&scoped=true&"
import script from "./asynclive.vue?vue&type=script&lang=js&"
export * from "./asynclive.vue?vue&type=script&lang=js&"
import style0 from "./asynclive.vue?vue&type=style&index=0&id=ac9d2876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9d2876",
  null
  
)

export default component.exports